module.exports = __webpack_public_path__ + "img/image-37.43ccf246.jpg";